import { normalizeTimeZoneId } from '@/constants/timeZones'

const getters = {
  token: state => state.user.token,
  userinfo: state => state.user.userinfo,
  /** 账号 IANA 时区，默认 Asia/Shanghai */
  accountTimeZone: state => {
    const tzId = state.user.userinfo && state.user.userinfo.timeZoneId
    if (tzId != null && tzId !== '') {
      return normalizeTimeZoneId(tzId)
    }
    const legacy = state.user.userinfo && state.user.userinfo.timeZone
    if (legacy != null && legacy !== '') {
      return normalizeTimeZoneId(legacy)
    }
    if (state.user.saveTimeZone != null && state.user.saveTimeZone !== '') {
      return normalizeTimeZoneId(state.user.saveTimeZone)
    }
    return normalizeTimeZoneId('')
  }
}
export default getters
